import React from 'react'

import { Link } from 'react-router-dom'

import { Button, ButtonGroup, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faList, faMap } from '@fortawesome/pro-regular-svg-icons'

import { useLocation } from 'components/ReactRouterProvider/context'

const pathnameContains = (path, location) => location.pathname.indexOf(path) !== -1

const useStyles = makeStyles((theme) => ({
  noAnchorStyles: {
    '&:focus': {
      outlineOffset: 'unset',
    },
  },
  contained: {
    '&:focus': {
      color: theme.palette.primary.contrastText,
    },
  },
  outlined: {
    '&:focus': {
      color: theme.palette.primary.main,
    },
  },
}))

export const MapListToggle = () => {
  const location = useLocation()
  const classes = useStyles()
  return (
    <ButtonGroup
      disableRipple
      color="primary"
    >
      <Button
        to={`${import.meta.env.BASE_URL}/recruit/explore/map${location.search}`}
        component={Link}
        variant={pathnameContains('/recruit/explore/map', location) ? 'contained' : 'outlined'}
        className={classes.noAnchorStyles}
        classes={{ contained: classes.contained, outlined: classes.outlined }}
      >
        <Typography variant="srOnly">map view</Typography>
        <FontAwesomeIcon
          size="xl"
          icon={faMap}
        />
      </Button>
      <Button
        component={Link}
        to={`${import.meta.env.BASE_URL}/recruit/explore/list${location.search}`}
        variant={pathnameContains('/recruit/explore/list', location) ? 'contained' : 'outlined'}
        className={classes.noAnchorStyles}
        classes={{ contained: classes.contained, outlined: classes.outlined }}
      >
        <Typography variant="srOnly">list view</Typography>
        <FontAwesomeIcon
          size="xl"
          icon={faList}
        />
      </Button>
    </ButtonGroup>
  )
}

export default MapListToggle
